// Display metadata only. Never infer the host from the viewing device or its name.
export function projectHostDevice(platform) {
  return platform === 'windows' ? 'PC' : platform === 'macos' ? 'Mac' : 'computer';
}

export function projectHostApp(platform) {
  return platform === 'windows' ? 'Gab AI Windows app' : platform === 'macos' ? 'Gab AI Mac app' : 'Gab AI desktop app';
}

export function projectHostSettings(platform) {
  return platform === 'windows' ? 'Projects → Remote access' : platform === 'macos' ? 'Settings → Remote Access' : 'Remote access';
}
